import React, { FC, useEffect, useState } from "react";
import { WiegandCard } from "./WiegandCard";
import FaceSettingsCard from "./FaceSettingsCard";
import CommsCard from "./CommsCard";
import { CONTROL_ID_SETTINGS } from "../../constants/preset-constants";
import { CONTROLID_WIEGAND_FIELDS, CONTROLID_COMMS_FIELDS } from "../../constants/biometric-fields-names";
import OsdpSettingCard from "./OsdpCard";
import TimeAndAttendance from "./TimeAndAttendanceCard";

interface ControlIdPresetProps {
    presetId?: string;
    presetCardType: string
}

export const ControlIdPresets: FC<ControlIdPresetProps> = ({ presetId = '', presetCardType }) => {
    const [content, setContent] = useState<any>([]);

    useEffect(() => {
        setTabContent();
    }, [presetCardType])

    const setTabContent = () => {
        switch (presetCardType) {
            case CONTROL_ID_SETTINGS.IDENTIFICATION:
                {
                    setContent([<CommsCard presetId={presetId} commsFields={CONTROLID_COMMS_FIELDS} />]);
                    break;
                }
            case CONTROL_ID_SETTINGS.FACE_SETTINGS:
                {
                    setContent([<FaceSettingsCard presetId={presetId} />]);
                    break;
                }
            case CONTROL_ID_SETTINGS.WIEGAND:
                {
                    setContent([<WiegandCard presetId={presetId} wiegandFields={CONTROLID_WIEGAND_FIELDS}
                    />]);
                    break;
                }
            case CONTROL_ID_SETTINGS.OSDP:
                {
                    setContent([<OsdpSettingCard presetId={presetId} />]);
                    break;
                }
            case CONTROL_ID_SETTINGS.TIME_AND_ATTENDANCE:
                {
                    setContent([<TimeAndAttendance presetId={presetId} isControlId={true}/>]);
                    break;
                }
            default: { };
        }
    }

    return (content);
};
